import { h } from '@stencil/core';

export default (
  <svg width="19" height="18" viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 7.485H3.5C3.5 5.01188 5.51188 3 7.985 3V4.5C6.33913 4.5 5 5.83913 5 7.485Z"/>
    <path d="M16.628 17.7751L13.9625 15.0961C13.6629 14.795 13.6637 14.3082 13.964 14.0082L14.5205 13.4517C14.822 13.1502 15.3107 13.151 15.6114 13.4532L18.2769 16.1322C18.5765 16.4334 18.5758 16.9201 18.2754 17.2201L17.7189 17.7766C17.4174 18.0781 16.9288 18.0774 16.628 17.7751Z"/>
    <path d="M7.95247 14.9753C3.82372 14.9753 0.464844 11.6164 0.464844 7.48763C0.464844 3.35888 3.82372 0 7.95247 0C12.0812 0 15.4401 3.35888 15.4401 7.48763C15.4401 11.6164 12.0812 14.9753 7.95247 14.9753ZM7.95247 1.5C4.65097 1.5 1.96484 4.18613 1.96484 7.48763C1.96484 10.7891 4.65097 13.4753 7.95247 13.4753C11.254 13.4753 13.9401 10.7891 13.9401 7.48763C13.9401 4.18613 11.254 1.5 7.95247 1.5Z"/>
  </svg>

);
